import PatientDetailComponent from "@components/PatientDetailComponent/PatientDetailComponent";
import styles from "./PatientDetailPage.module.css";
import { useParams } from "react-router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import usePatient from "@hooks/usePatient";

const PatientDetailPage = () => {
  const { email } = useParams();
  const { handleGetPatientById } = usePatient();
  const { singlePatientData } = useSelector((state) => state.patient);

  useEffect(() => {
    if (email) {
      handleGetPatientById(email);
    }
  }, [email]);

  return (
    <div className={styles.Wrapper}>
      <PatientDetailComponent patientData={singlePatientData?.data[0]} />
    </div>
  );
};

export default PatientDetailPage;
